import { Fund, Funds } from "~/models/fund";
import { Nonprofit, Nonprofits } from "~/models/list";
import { API_CAUSES_FUNDS_URL, API_CAUSES_LISTS_URL } from "./base";
import { wpFetch } from "./wpfetch";

const getNonprofits = (json: any, randomize: boolean) => {
  if (!json || !json.groups) {
    console.error("Invalid JSON structure for nonprofits");
    return [];
  }

  const nonprofits: any[] = [];

  // go through each group and extract nonprofits
  json.groups.map((group: any) => {
    const groupNonprofits: any[] = group.nonprofits || [];
    nonprofits.push(...groupNonprofits);
  });

  if (randomize) {
    // Shuffle the nonprofits array if randomize is true
    nonprofits.sort(() => Math.random() - 0.5);
  }

  return nonprofits;
};

export const getWtgnList = async (
  listId: number,
  randomize: boolean,
): Promise<Nonprofit[]> => {
  try {
    // this accesses a PHP endpoint defined in index.php  which gets the list
    const json = await wpFetch(`${API_CAUSES_LISTS_URL}/${listId}`);

    return getNonprofits(json, randomize);
  } catch (error) {
    console.error("Error fetching WTGN list:", error);

    throw error;
  }
};

export const getWtgnLists = async (): Promise<Nonprofits[]> => {
  // this accesses a PHP endpoint defined in index.php  which gets the list
  const json = await wpFetch(`${API_CAUSES_LISTS_URL}`);

  // sort the list by name
  json.sort((a: any, b: any) => a.name.localeCompare(b.name));
  return json;
};

export const getFund = async (
  fundId: number,
  randomize: boolean,
): Promise<Fund[]> => {
  // this accesses a PHP endpoint defined in index.php  which gets the list
  const json = await wpFetch(`${API_CAUSES_FUNDS_URL}/${fundId}`);

  return getNonprofits(json, randomize);
};

export const getFunds = async (): Promise<Funds[]> => {
  // this accesses a PHP endpoint defined in index.php  which gets the list
  const json = await wpFetch(`${API_CAUSES_FUNDS_URL}`);

  // sort the list by name
  json.sort((a: any, b: any) => a.name.localeCompare(b.name));
  return json;
};
